import { useState, useEffect } from "react";
import {
  Typography,
  Stack,
  TextField,
  Divider,
  Button,
  Box,
  InputAdornment,
  Paper,
  Tab,
  Tabs,
  IconButton,
  Chip,
  Autocomplete,
  Modal,
  MenuItem,
  Select,
} from "@mui/material";
import {
  NavigateBefore,
  Add,
  Check,
  ChevronLeft,
  Close,
  Search,
} from "@mui/icons-material";
import { ReactComponent as IconSuccess } from "../../images/dialogs/success.svg";
import { ReactComponent as IconWarning } from "../../images/iconWarning.svg";

import CardPaciente from "../../components/CardPaciente";

import { useParams } from "react-router-dom";

import { DataGrid, ptBR } from "@mui/x-data-grid";
import marker from "../../images/Markers.png";
import api from "../../services/api";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import { getItemDecrypt } from "../../utils/cryptoData";

const historicoLista = [
  {
    titulo: "Fernando Silva",
    profissao: "Medico ",
    data: "16 de Março de 2023 às 10:10",
    tipo: "Emitir Prescrição",
    ip: "192.168.15.0",
  },
];

export default function AcessoPaciente() {
  const { id } = useParams();

  const [duracaoAcesso, setDuracaoAcesso] = useState("");
  const [justificativa, setJustificativa] = useState("");
  const [solicitado, setSolicitado] = useState("");
  const [count, setCount] = useState(0);

  const [tabValue, setTabValue] = useState(0);
  const [verDetalhes, setVerDetalhes] = useState(false);
  const [novoCompartilhamento, setNovoCompartilhamento] = useState(false);
  //Novo compartilhamento
  const [rowsCompartilhamento, setRowsCompartilhamento] = useState([]);
  const [rowsSolicitacoes, setRowsSolicitacoes] = useState([]);
  const [rowsHistoricoAcessos, setRowsHistoricoAcessos] = useState([]);
  const [vinculoProfissionaisList, setVinculoProfissionaisList] = useState([]);
  const [vinculoSolicitacao, setVinculoSolicitacao] = useState({});
  const [editar, setEditar] = useState(false);
  const [compartilhamentoIdEditar, setCompartilhamentoIdEditar] = useState(0);
  const [campoBusca, setCampoBusca] = useState("");

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openError, setOpenError] = useState(false);
  const handleOpenError = () => setOpenError(true);
  const handleCloseError = () => setOpenError(false);

  const [tituloModal, setTituloModal] = useState("");
  const [mensagemModal, setMensagemModal] = useState("");

  const [dadosFiltradosCompartilhamento, setDadosFiltradosCompartilhamento] =
    useState("");
  const [dadosFiltradosSolicitacoes, setDadosFiltradosSolicitacoes] =
    useState("");
  const [dadosFiltradosHistoricoAcessos, setDadosFiltradosHistoricoAcessos] =
    useState("");

  const idVinculo = getItemDecrypt("vinculo_ativo").id;

  useEffect(() => {
    getCompartilhamentos();
    getSolicitacoes();
    getHistoricoAcessos();
    handleVinculosSelecionaveis();
  }, []);

  const getCompartilhamentos = async () => {
    try {
      const { data } = await api.get(`/compartilhamentos-acesso/${id}`);

      setRowsCompartilhamento(data);
      setDadosFiltradosCompartilhamento(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  const getSolicitacoes = async () => {
    try {
      const { data } = await api.get(`/solicitacoes-acesso/${id}`);

      setRowsSolicitacoes(data);
      setDadosFiltradosSolicitacoes(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  const getHistoricoAcessos = async () => {
    try {
      const { data } = await api.get(`/historico-acessos/${id}`);

      setRowsHistoricoAcessos(data);
      setDadosFiltradosHistoricoAcessos(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  useEffect(() => {
    if (tabValue !== 0) {
      setVerDetalhes(false);
    }
    if (tabValue !== 1) {
      setNovoCompartilhamento(false);
    }
  }, [tabValue]);

  const handleUpdateStatusAcesso = async (idAcesso, status) => {
    try {
      const { data } = await api.post(`/atualizar-acesso/`, {
        id_permission: idAcesso,
        new_status: status,
        id_vinculo_autorizador: idVinculo,
      });

      getCompartilhamentos();
      getSolicitacoes();
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  const handleShowNovoCompartilhamento = () => {
    setDuracaoAcesso("");
    setJustificativa("");
    setVinculoSolicitacao({});
    setEditar(false);
    setNovoCompartilhamento(true);
  };

  const handleBusca = (value) => {
    setCampoBusca(value);

    if (value.length === 0) {
      setDadosFiltradosCompartilhamento(rowsCompartilhamento);
      setDadosFiltradosSolicitacoes(rowsSolicitacoes);
      setDadosFiltradosHistoricoAcessos(rowsHistoricoAcessos);
      return;
    }

    const dadosFiltradosComp = rowsCompartilhamento.filter(
      (item) =>
        item.identificacao.toLowerCase().includes(value.toLowerCase()) ||
        item.dadosCompartilhamento.solicitante.cpf
          .toLowerCase()
          .includes(value.toLowerCase())
    );

    const dadosFiltradosSol = rowsSolicitacoes.filter(
      (item) =>
        item.identificacao.toLowerCase().includes(value.toLowerCase()) ||
        item.cpfSolicitante.toLowerCase().includes(value.toLowerCase())
    );

    const dadosFiltradosHist = rowsHistoricoAcessos.filter(
      (item) =>
        item.identificacao.toLowerCase().includes(value.toLowerCase()) ||
        item.cpfProfissional.toLowerCase().includes(value.toLowerCase())
    );

    setDadosFiltradosCompartilhamento(dadosFiltradosComp);
    setDadosFiltradosSolicitacoes(dadosFiltradosSol);
    setDadosFiltradosHistoricoAcessos(dadosFiltradosHist);
  };

  const handleNovoCompartilhamento = async () => {
    if (justificativa.length > 0 && vinculoSolicitacao !== null) {
      try {
        const response = await api.post("/permissao-acesso/", {
          data: {
            id_vinculo_solicitante: vinculoSolicitacao.id,
            id_paciente: parseInt(id),
            justification: justificativa,
            duration: duracaoAcesso,
            st_permissao: true,
            id_vinculo_autorizador: idVinculo,
          },
        });

        if (response.data.error !== undefined && response.data.error !== null) {
          handleOpenError();
          return;
        }

        setTituloModal("Compartilhamento ativo");
        setMensagemModal(
          "Compartilhamento de dados clínicos do paciente concedido com sucesso"
        );
        handleOpen();
        setNovoCompartilhamento(false);
        getCompartilhamentos();
      } catch (error) {
        console.error("Ocorreu um erro:", error.message);
      }
    }
  };

  const handleAtualizarCompartilhamento = async () => {
    if (justificativa.length > 0 && vinculoSolicitacao !== null) {
      try {
        const response = await api.put("/compartilhamento/", {
          data: {
            id_vinculo_solicitante: vinculoSolicitacao.id,
            id_paciente: parseInt(id),
            justification: justificativa,
            duration: duracaoAcesso,
            id_vinculo_autorizador: idVinculo,
            id_compartilhamento: parseInt(compartilhamentoIdEditar),
          },
        });

        if (response.data.error !== undefined && response.data.error !== null) {
          return;
        }

        setTituloModal("Compartilhamento atualizado");
        setMensagemModal(
          "Compartilhamento de dados clínicos do paciente atualizado com sucesso"
        );
        handleOpen();
        setNovoCompartilhamento(false);
        getCompartilhamentos();
      } catch (error) {
        console.error("Ocorreu um erro:", error.message);
      }
    }
  };

  const handleVinculosSelecionaveis = async () => {
    try {
      const { data } = await api.get(`compartilhamento/vinculos/${idVinculo}`);

      setVinculoProfissionaisList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  const handleEditar = async (compartilhamentoSelecionado) => {
    const dadosCompartilhamento = rowsCompartilhamento.find(
      (compartilhamento) =>
        compartilhamento.dadosCompartilhamento.id ===
        compartilhamentoSelecionado.id
    ).dadosCompartilhamento;

    setDuracaoAcesso(dadosCompartilhamento.dataExpiracao);
    setVinculoSolicitacao({
      estabelecimento: dadosCompartilhamento.solicitante.estabelecimento,
      cpf: dadosCompartilhamento.solicitante.cpf,
      id: dadosCompartilhamento.solicitante.id,
      nome: dadosCompartilhamento.solicitante.nome,
      perfil: dadosCompartilhamento.solicitante.perfil,
    });
    setJustificativa(dadosCompartilhamento.justificativa);
    setEditar(true);
    setNovoCompartilhamento(true);
    setCompartilhamentoIdEditar(compartilhamentoSelecionado.id);
  };

  const historicoColumns = [
    {
      field: "identificacao",
      headerName: "Identificação",
      flex: 1,
      renderCell: (params) =>
        params.row && (
          <>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Nunito",
                fontWeight: 400,
                paddingY: "8px",
              }}
            >
              {params.row.identificacao}
            </Typography>
          </>
        ),
    },
    {
      field: "acessos",
      headerName: "Acessos",
      width: 150,
    },
    {
      field: "primeiroAcesso",
      headerName: "Primeiro Acesso",
      width: 125,
    },
    {
      field: "ultimoAcesso",
      headerName: "Útimo acesso",
      width: 125,
    },
    {
      field: "actions",
      headerName: "Ações",
      width: 200,
      sortable: false,

      renderCell: (params) => {
        return (
          <>
            {params.row && (
              <Button
                variant="contained"
                sx={{ backgroundColor: "#1E729F", height: "30px" }}
                onClick={() => {
                  setVerDetalhes(true);
                }}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontSize: "16px",
                    fontWeight: "500",
                    fontFamily: "Nunito",
                    width: "120px",
                  }}
                >
                  Ver Detalhes
                </Typography>
              </Button>
            )}
          </>
        );
      },
    },
  ];

  const compartilhamentoColumns = [
    {
      field: "identificacao",
      headerName: "Identificação",
      flex: 1,
      renderCell: (params) =>
        params.row && (
          <>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Nunito",
                fontWeight: 400,
                paddingY: "8px",
              }}
            >
              {params.row.identificacao}
            </Typography>
          </>
        ),
    },
    {
      field: "permissao",
      headerName: "Permissão",
      width: 150,

      renderCell: (params) => {
        return (
          <>
            {params.row && params.row.permissao && (
              <Chip
                variant="contained"
                sx={{ bgcolor: "#c8ecc7", width: "120px" }}
                label={
                  <Typography
                    sx={{
                      color: "#3AB238",
                      textTransform: "capitalize",
                      fontSize: "16px",
                      fontWeight: "500",
                      fontFamily: "Nunito",
                    }}
                  >
                    Ativa
                  </Typography>
                }
              />
            )}
            {params.row && !params.row.permissao && (
              <Chip
                variant="contained"
                sx={{ bgcolor: "#E4BABA", width: "120px" }}
                label={
                  <Typography
                    sx={{
                      color: "#8D0909",
                      textTransform: "capitalize",
                      fontSize: "16px",
                      fontWeight: "500",
                      fontFamily: "Nunito",
                    }}
                  >
                    Bloqueado
                  </Typography>
                }
              />
            )}
          </>
        );
      },
    },
    {
      field: "compartilhadoPor",
      headerName: "Compartilhado Por",
      width: 220,
      renderCell: (params) =>
        params.row && (
          <>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Nunito",
                fontWeight: 400,
                paddingY: "8px",
              }}
            >
              {params.row.compartilhadoPor}
            </Typography>
          </>
        ),
    },
    {
      field: "expiraEm",
      headerName: "Expira em",
      width: 150,
    },
    {
      field: "actions",
      headerName: "Ações",
      width: 200,
      sortable: false,

      renderCell: (params) => {
        return (
          <>
            {params.row && (
              <Button
                variant="contained"
                sx={{ backgroundColor: "#1E729F", height: "30px" }}
                onClick={() => {
                  handleEditar(params.row);
                }}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontSize: "16px",
                    fontWeight: "500",
                    fontFamily: "Nunito",
                    width: "120px",
                  }}
                >
                  Editar
                </Typography>
              </Button>
            )}
          </>
        );
      },
    },
  ];

  const solicitacoesColumns = [
    {
      field: "identificacao",
      headerName: "Identificação",
      flex: 1,
      renderCell: (params) =>
        params.row && (
          <>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Nunito",
                fontWeight: 400,
                paddingY: "8px",
              }}
            >
              {params.row.identificacao}
            </Typography>
          </>
        ),
    },
    {
      field: "justificativa",
      headerName: "Justificativa",
      width: 240,
      renderCell: (params) =>
        params.row && (
          <>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Nunito",
                fontWeight: 400,
                paddingY: "8px",
              }}
            >
              {params.row.justificativa}
            </Typography>
          </>
        ),
    },
    {
      field: "dataSolicitacao",
      headerName: "Data de solicitação",
      width: 140,
    },
    {
      field: "expiraEm",
      headerName: "Expira em",
      width: 140,
    },
    {
      field: "actions",
      headerName: "Ações",
      width: 140,
      sortable: false,

      renderCell: (params) => {
        return (
          <>
            {params.row && (
              <Stack direction={"row"} gap={2}>
                <IconButton>
                  <Check
                    color="success"
                    onClick={() => {
                      handleUpdateStatusAcesso(params.row.id, true);
                    }}
                  />
                </IconButton>
                <IconButton>
                  <Close
                    color="error"
                    onClick={() => {
                      handleUpdateStatusAcesso(params.row.id, false);
                    }}
                  />
                </IconButton>
              </Stack>
            )}
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setCount(justificativa.length);
  }, [justificativa]);

  const styles = {
    title: {
      fontWeight: "300",
      fontSize: "1.5rem",
      lineHeight: "25px",
      color: "#063F5E",
      textAlign: "center",
      lineHeight: "2.5rem",
    },
    subtitle: {
      fontWeight: "300",
      fontSize: "1.2rem",
      lineHeight: "25px",
      marginBottom: "5px",
      marginTop: "10px",
      color: "#1E729F",
    },
    diamond: {
      fill: "#1E729F",
    },
    modal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      textAlign: "center",
      zoom: "70%",
    },
  };

  return (
    <Box sx={{ mb: 10 }}>
      <Box>
        <ButtonGoBack />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box style={styles.title}>Acessos</Box>
          <Button variant="contained" endIcon={<Add />} disabled>
            Iniciar consulta
          </Button>
        </Box>

        <CardPaciente id={id} />

        <Paper
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "auto",
            padding: "32px 12px",
            gap: "24px",
          }}
        >
          <Box sx={{ width: "500px", borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabValue}
              onChange={(event, newValue) => {
                setTabValue(newValue);
              }}
            >
              <Tab
                label={"Histórico de acesso"}
                sx={{ textTransform: "none" }}
                value={0}
              />
              <Tab
                label={"Compartilhamento"}
                sx={{ textTransform: "none" }}
                value={1}
              />
              <Tab
                label={"Solicitações"}
                sx={{ textTransform: "none" }}
                value={2}
              />
            </Tabs>
          </Box>
          <Stack direction={"row"} gap={"10px"} /* "1014px"*/>
            <Box width={"100%"}>
              <TextField
                placeholder="Buscar por Nome, CPF ou CNES"
                size="small"
                sx={{ width: "100%" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                value={campoBusca}
                onChange={(e) => handleBusca(e.target.value)}
              />
            </Box>
            {tabValue === 1 && (
              <Button
                startIcon={<Add />}
                variant="contained"
                sx={{ backgroundColor: "#1E729F", width: "300px" }}
                onClick={() => {
                  handleShowNovoCompartilhamento();
                }}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontSize: "16px",
                    fontWeight: "500",
                    fontFamily: "Nunito",
                  }}
                >
                  Novo compartilhamento
                </Typography>
              </Button>
            )}
          </Stack>
          <Box sx={{ display: "flex", height: "400px", width: "1014px" }}>
            {verDetalhes && (
              <Box width={"100%"}>
                <Button
                  startIcon={<ChevronLeft sx={{ mt: -0.2 }} />}
                  onClick={() => {
                    setVerDetalhes(false);
                  }}
                >
                  Voltar
                </Button>
                <Typography
                  fontFamily={"Nunito"}
                  fontSize={"20px"}
                  fontWeight={500}
                  sx={{ color: "#1E729F", mt: 1, mb: 1 }}
                >
                  Detalhes do acesso
                </Typography>
                {historicoLista.map((lista) => {
                  /* titulo: "Fernando Silva",
                profissao: "Medico ",
                data: "16 de Março de 2023 às 10:10",
                tipo: "Emitir Prescrição",
                ip: "192.168.15*/
                  return (
                    <Paper
                      variant="outlined"
                      sx={{
                        backgroundColor: "#EFF5F7",
                        display: "flex",
                        flexDirection: "column",
                        padding: "16px",
                        gap: "8px",
                      }}
                    >
                      <Stack direction={"row"} gap={1}>
                        <Typography
                          fontFamily={"Nunito"}
                          fontSize={"16px"}
                          fontWeight={600}
                        >
                          {lista.titulo} | {lista.profissao}
                        </Typography>

                        <Typography> {` ${lista.data}`}</Typography>
                      </Stack>
                      <Typography sx={{ color: "#063F5E" }}>
                        {" "}
                        {lista.tipo}
                      </Typography>
                      <Typography sx={{ color: "#737373" }}>
                        {" "}
                        {lista.ip}
                      </Typography>
                    </Paper>
                  );
                })}
              </Box>
            )}
            {novoCompartilhamento && (
              <Box width={"100%"}>
                <Button
                  startIcon={<ChevronLeft sx={{ mt: -0.2 }} />}
                  onClick={() => {
                    setNovoCompartilhamento(false);
                  }}
                >
                  Voltar
                </Button>
                <Typography
                  fontFamily={"Nunito"}
                  fontSize={"20px"}
                  fontWeight={500}
                  sx={{ color: "#1E729F", mt: 1, mb: 1 }}
                >
                  Novo compartilhamento
                </Typography>
                <Stack>
                  <Stack direction={"column"} gap={"24px"}>
                    <Stack direction={"row"} gap={"24px"}>
                      <Stack width={"50%"}>
                        <Typography
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            fontWeight: 600,
                            color: "#063F5E",
                          }}
                        >
                          Identificação <img src={marker} alt="maker" />
                        </Typography>
                        <Autocomplete
                          options={vinculoProfissionaisList}
                          noOptionsText={"Nenhum resultado encontrado"}
                          getOptionLabel={(option) =>
                            option.id
                              ? `${option.nome} - ${option.cpf} - ${option.perfil} - CNES: ${option.estabelecimento}`
                              : ""
                          }
                          value={vinculoSolicitacao}
                          onChange={(e, newValue) =>
                            setVinculoSolicitacao(newValue)
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          renderTags={() => null}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              variant="outlined"
                              placeholder="Digite seu CPF ou CNS"
                            />
                          )}
                        />
                      </Stack>
                      <Stack width={"50%"}>
                        <Typography
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            fontWeight: 600,
                            color: "#063F5E",
                          }}
                        >
                          Duração de acesso <img src={marker} alt="maker" />
                        </Typography>

                        <Select
                          style={{ borderRadius: 10 }}
                          required
                          value={duracaoAcesso}
                          onChange={(event) => {
                            setDuracaoAcesso(event.target.value);
                          }}
                        >
                          <MenuItem disabled value={""}>
                            Selecione
                          </MenuItem>
                          <MenuItem value={"1"}>1 hora</MenuItem>
                          <MenuItem value={"1"}>1 dia</MenuItem>
                          <MenuItem value={"1"}>1 Semana</MenuItem>
                          <MenuItem value={"1"}>Sempre</MenuItem>
                        </Select>
                      </Stack>
                    </Stack>
                    <Stack width={"100%"}>
                      <Typography
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          fontWeight: 600,
                          color: "#063F5E",
                        }}
                      >
                        Justificativa
                        <img src={marker} alt="maker" />
                      </Typography>
                      <TextField
                        placeholder="Descreva a justificativa"
                        multiline
                        fullWidth
                        value={justificativa}
                        onChange={(event) => {
                          setJustificativa(event.target.value);
                        }}
                      />
                    </Stack>
                    <Divider />
                    <Stack direction={"row"} justifyContent={"space-between"}>
                      <Button
                        sx={{ color: "#1E729F" }}
                        variant="outlined"
                        onClick={() => {
                          setNovoCompartilhamento(false);
                        }}
                      >
                        Cancelar
                      </Button>
                      {editar ? (
                        <Button
                          sx={{ color: "#1E729F" }}
                          variant="outlined"
                          onClick={() => {
                            handleAtualizarCompartilhamento();
                          }}
                        >
                          Editar
                        </Button>
                      ) : (
                        <Button
                          sx={{ color: "#1E729F" }}
                          variant="outlined"
                          onClick={() => {
                            handleNovoCompartilhamento();
                          }}
                        >
                          Salvar
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            )}

            {!verDetalhes && !novoCompartilhamento && (
              <DataGrid
                rows={
                  tabValue == 0
                    ? dadosFiltradosHistoricoAcessos
                    : tabValue == 1
                    ? dadosFiltradosCompartilhamento
                    : dadosFiltradosSolicitacoes
                }
                columns={
                  tabValue == 0
                    ? historicoColumns
                    : tabValue == 1
                    ? compartilhamentoColumns
                    : solicitacoesColumns
                }
                disableColumnMenu
                getRowHeight={() => "auto"}
                rowsPerPageOptions={[10, 50, 100]}
                disableRowSelectionOnClick={true}
                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                initialState={{
                  ...rowsHistoricoAcessos.initialState,
                  pagination: {
                    pageSize: 10,
                  },
                }}
              />
            )}
          </Box>
        </Paper>
      </Box>
      <Modal open={open} onClose={handleClose}>
        <Box style={styles.modal}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#3AB238 !important",
              p: 2,
            }}
          >
            <Stack direction="row" sx={{ gap: 2 }}>
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              >
                {tituloModal}
              </Typography>
            </Stack>

            <IconButton onClick={handleClose}>
              <Close sx={{ color: "white" }} />
            </IconButton>
          </Box>
          <Box sx={{ padding: "4rem 1rem" }}>
            <IconSuccess width="8rem" height="6rem" />
            <Typography
              id="modal-modal-description"
              sx={{
                mt: 2,
                color: "#3AB238",
                fontSize: "1.5rem",
                fontWeight: "bold",
              }}
            >
              {mensagemModal}
            </Typography>
          </Box>
        </Box>
      </Modal>
      <Modal open={openError} onClose={handleCloseError}>
        <Box style={styles.modal}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#FC8618 !important",
              p: 2,
            }}
          >
            <Stack direction="row" sx={{ gap: 2 }}>
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              >
                Compartilhamento já existe
              </Typography>
            </Stack>

            <IconButton onClick={handleCloseError}>
              <Close sx={{ color: "white" }} />
            </IconButton>
          </Box>
          <Box sx={{ padding: "4rem 1rem" }}>
            <IconWarning width="8rem" height="6rem" />
            <Typography
              id="modal-modal-description"
              sx={{
                mt: 2,
                color: "#FC8618",
                fontSize: "1.5rem",
                fontWeight: "bold",
              }}
            >
              Já existe um compartilhamento ativo para o profissional de saúde
              selecionado.
            </Typography>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
